<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.zsmj1">&nbsp; &nbsp;
        <img :src="images.zsmj2" style="line-height:1.5;">
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <span style="font-size:18px;font-family:宋体;">INJECT MOULD</span>
        </b>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        zsmj1: require("../../../assets/img/common/zsmj1.jpg"),
        zsmj2: require("../../../assets/img/common/zsmj2.jpg"),
        zsmj3: require("../../../assets/img/common/zsmj3.jpg")
      }
    };
  },

  components: {},

  computed: {},

  mounted: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/en/device/zsmj.vue